import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import './SiteHeader.css';

const SiteHeader = () => {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link to="/" className="site-header__brand">
          seanderham.com
        </Link>

        <nav className="site-header__nav">
          <NavLink
            to="/index"
            className={({ isActive }) =>
              `site-header__link${isActive ? ' is-active' : ''}`
            }
          >
            INDEX
          </NavLink>
          <NavLink
            to="/showreel"
            className={({ isActive }) =>
              `site-header__link${isActive ? ' is-active' : ''}`
            }
          >
            SHOWREEL
          </NavLink>
          <NavLink
            to="/videography"
            className={({ isActive }) =>
              `site-header__link${isActive ? ' is-active' : ''}`
            }
          >
            VIDEOGRAPHY
          </NavLink>
          <NavLink
            to="/info"
            className={({ isActive }) =>
              `site-header__link${isActive ? ' is-active' : ''}`
            }
          >
            INFO
          </NavLink>
        </nav>
      </div>
    </header>
  );
};

export default SiteHeader;
